import error404PageConfig from '@ameroservices-platform/attraction-flexposui/app/main/apps/error/404/error404PageConfig';
import error500PageConfig from '@ameroservices-platform/attraction-flexposui/app/main/apps/error/500/error500PageConfig';
import FlexposTimeslotSaleConfig from '@ameroservices-platform/attraction-flexposui/app/main/apps/flexposTimeslotAndUpsale/FlexposTimeslotSaleConfig';
import FlexposEventSaleConfig from '@ameroservices-platform/attraction-flexposui/app/main/apps/flexposEventSale/FlexposEventSaleConfig';

const appsConfigs = [error404PageConfig, error500PageConfig, FlexposTimeslotSaleConfig, FlexposEventSaleConfig];

export default appsConfigs;
